import React, { useState } from 'react';
import TreeItem from '../TreeItem/TreeItem';
import './BarChart.css';

const BarChart = ({ data, setCurrentPath, loading, setLoading }) => {
  const [openItems, setOpenItems] = useState([])

  const handleToggle = (itemKey, level) => {
    setOpenItems(prev => {
      const newOpenItems = prev.filter(key => !key.startsWith(`level-${level}:`));
      if (!prev.includes(itemKey)) {
        newOpenItems.push(itemKey);
      }
      return newOpenItems;
    });
  }; 

  return (
    <div className="bar-chart">
      {setCurrentPath && (<TreeItem 
        item={data}
        total={data.baseline_sum}
        onToggle={handleToggle}
        openItems={openItems}
        setCurrentPath={setCurrentPath}
        loading={loading}
        setLoading={setLoading}
      />)}
      
    </div>
  );
};


export default BarChart;